import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useBranding } from "../contexts/brandingContext";
const Sidebar = () => {

    const location = useLocation();
    const navigation = location.pathname;
    const [isOrdersMenuOpen, setIsOrdersMenuOpen] = useState(false);
    const [isPaymentsMenuOpen, setIsPaymentsMenuOpen] = useState(false);

    const handleOrdersMenuToggle = () => {
        setIsOrdersMenuOpen(true);
        setIsPaymentsMenuOpen(false);
    };
    const handlePaymentsMenuToggle = () => {
        setIsPaymentsMenuOpen(true);
        setIsOrdersMenuOpen(false);
    };
    const { existingLogo } = useBranding();


    return (
        <div className="sidebar">
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                {existingLogo ? (
                    <a href="#" className="brand-link text-decoration-none head">
                        <img
                            src={existingLogo}
                            alt="user"
                            className="img-fluid first-img brand-text mt-1"
                            style={{
                                width: "180px", height: "100%", maxWidth: "100%", objectFit: "cover"
                            }}
                        />
                    </a>
                ) : (
                    <a href="#" className="brand-link text-decoration-none head">
                        <h2 className="brand-text mt-1 first-img">
                            Yiannis
                            <span className="brand-subtext d-block">Foods and Wines</span>
                        </h2>
                    </a>
                )}

                <div className="sidebar">

                    <ul className="ps-0  nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false" style={{ listStyle: "none" }}>
                        <li className="nav-item">
                            <h6 className="menu mt-2">Menu</h6>
                        </li>
                        <li className="nav-item">
                            <Link to="/dashboard"
                            className={`nav-link ${
                                navigation.startsWith("/dashboard")
                                ? "active"
                                : ""
                                } `}
                                >
                                <i className="fa-solid fa-gauge me-3"></i>
                                <p className="">Dashboard</p>
                            </Link>
                        </li>
                        <li className={`nav-item ${isOrdersMenuOpen ? "menu-open" : ""}`}>
                            <Link
                                className={`nav-link ${navigation === "/invoices" ||
                                    navigation.startsWith("/invoice-detail")
                                    ? "active"
                                    : ""
                                    } `}
                                onClick={() => handleOrdersMenuToggle()}>
                                <i className="fa-solid fa-bag-shopping me-3"></i>
                                <p>
                                    <span className="">Purchases</span>
                                    <i className="right fas fa-angle-right"></i>
                                </p>
                            </Link>
                            <ul className="nav nav-treeview">
                                <li className="nav-item">
                                    <Link to="/invoices" className="nav-link">
                                        <i
                                            className={`${navigation.startsWith("/invoices")
                                                ? "far fa-circle-check nav-icon me-3"
                                                : "far fa-circle nav-icon me-3"
                                                } `}></i>
                                        <p>Invoices</p>
                                    </Link>
                                </li>
                            </ul>
                            <ul className="nav nav-treeview">
                                <li className="nav-item">
                                    <Link to="/invoice-detail" className="nav-link">
                                        <i
                                            className={`${navigation.startsWith("/invoice-detail")
                                                ? "far fa-circle-check nav-icon me-3"
                                                : "far fa-circle nav-icon me-3"
                                                } `}></i>
                                        <p>Invoice Detail</p>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li className={`nav-item ${isPaymentsMenuOpen ? "menu-open" : ""}`}>
                            <Link
                                className={`nav-link ${navigation === "/paymentHistory" ||
                                    navigation === "/paymentMethods"
                                    ? "active"
                                    : ""
                                    } `}
                                onClick={() => handlePaymentsMenuToggle()}>
                                <i className="fa-solid fa-money-check-dollar me-3"></i>
                                <p>
                                    <span className="">Payments</span>
                                    <i className="right fas fa-angle-right"></i>
                                </p>
                            </Link>
                            <ul className="nav nav-treeview">
                                <li className="nav-item">
                                    <Link to="/paymentHistory" className="nav-link">
                                        <i
                                            className={`${navigation.startsWith("/paymentHistory")
                                                ? "far fa-circle-check nav-icon me-3"
                                                : "far fa-circle nav-icon me-3"
                                                } `}></i>
                                        <p>Payment History</p>
                                    </Link>
                                </li>
                            </ul>
                            <ul className="nav nav-treeview">
                                <li className="nav-item">
                                    <Link to="/paymentMethods" className="nav-link">
                                        <i
                                            className={`${navigation.startsWith("/paymentMethods")
                                                ? "far fa-circle-check nav-icon me-3"
                                                : "far fa-circle nav-icon me-3"
                                                } `}></i>
                                        <p>Payment Methods</p>
                                    </Link>
                                </li>
                            </ul>
                        </li>

                    </ul>

                </div>

            </aside>
        </div>
    );
};

export default Sidebar;